(() => {
const random = (min, max) => min + Math.random() * (max - min);
const lightFrame = light => ({
'--arm-light-x': light.x + 'px',
'--arm-light-y': light.y + 'px',
'--arm-light-blur': light.blur + 'px',
'--arm-light-alpha': light.alpha
});
function mount() {
document.querySelectorAll('[data-arm-featured-motion]').forEach(root => {
if (root.dataset.motionReady) return;
const button = root.querySelector('[data-arm-motion-toggle]');
const images = [...root.querySelectorAll('.arm-featured-item .photo img')];
if (!button || !images.length || !images.every(image => typeof image.animate === 'function')) return;
root.dataset.motionReady = 'true';
const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
const states = images.map(image => ({
image, scale: random(.92, 1.12), growing: Math.random() > .5,
light: {x: random(-10, 12), y: random(8, 16), blur: random(7, 11), alpha: random(.28, .42)},
animation: null, lightAnimation: null
}));
let stopped = false;
function isPaused() { return root.dataset.motionPaused === 'true' || document.hidden; }
function available() {
if (stopped || preference.matches) return false;
if (!root.isConnected) { stop(); return false; }
return true;
}
function step(state) {
if (!available()) return;
const target = state.growing ? random(1.07, 1.12) : random(.92, .97);
state.image.style.transform = 'scale(' + state.scale + ')';
if (state.animation) state.animation.cancel();
const animation = state.image.animate(
[{transform: 'scale(' + state.scale + ')'}, {transform: 'scale(' + target + ')'}],
{duration: random(3500, 8500), easing: 'ease-in-out', fill: 'forwards'}
);
state.animation = animation;
if (isPaused()) animation.pause();
animation.finished.then(() => {
if (stopped || preference.matches) return;
state.scale = target;
state.growing = !state.growing;
step(state);
}).catch(() => {});
}
function drift(state) {
if (!available()) return;
const target = {
x: state.light.x >= 0 ? random(-12, -4) : random(4, 14),
y: random(7, 18), blur: random(6, 13), alpha: random(.24, .44)
};
Object.entries(lightFrame(state.light)).forEach(([property, value]) => state.image.style.setProperty(property, value));
if (state.lightAnimation) state.lightAnimation.cancel();
const animation = state.image.animate(
[lightFrame(state.light), lightFrame(target)],
{duration: random(6000, 13000), easing: 'ease-in-out', fill: 'forwards'}
);
state.lightAnimation = animation;
if (isPaused()) animation.pause();
animation.finished.then(() => {
if (stopped || preference.matches) return;
state.light = target;
drift(state);
}).catch(() => {});
}
function sync() {
button.hidden = preference.matches;
states.forEach(state => {
if (preference.matches) {
[state.animation, state.lightAnimation].forEach(animation => { if (animation) animation.cancel(); });
state.animation = null;
state.lightAnimation = null;
state.image.style.transform = '';
Object.keys(lightFrame(state.light)).forEach(property => state.image.style.removeProperty(property));
} else {
if (!state.animation) step(state);
if (!state.lightAnimation) drift(state);
[state.animation, state.lightAnimation].forEach(animation => {
if (!animation) return;
if (isPaused()) animation.pause();
else animation.play();
});
}
});
}
function stop() {
stopped = true;
states.forEach(state => [state.animation, state.lightAnimation].forEach(animation => { if (animation) animation.cancel(); }));
document.removeEventListener('visibilitychange', sync);
preference.removeEventListener('change', sync);
}
button.addEventListener('click', () => {
const paused = root.dataset.motionPaused !== 'true';
root.dataset.motionPaused = String(paused);
button.setAttribute('aria-pressed', String(paused));
button.textContent = paused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
sync();
});
document.addEventListener('visibilitychange', sync);
preference.addEventListener('change', sync);
sync();
});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
else mount();
document.addEventListener('shopify:section:load', mount);
})();